<template>
  <aha-modal-group
    @hide="hide()"
  >
    <template #header>
      <div>
        <aha-icon-container
          class="font-bold truncate cursor-pointer"
          size="md"
          icon-class="bg-primary-90 text-base-0"
        >
          <aha-icon
            name="share-collab"
            width="14"
            height="14"
            viewBox="0 0 18 16"
          />
        </aha-icon-container>
        <span>
          Invite to edit
        </span>
      </div>
    </template>
    <template #main>
      <div class="font-light text-xs">
        Collaboration is currently limited to {{ teamName }} members only.
      </div>
      <div class="list-member">
        <div
          v-for="member in teamMembers"
          :key="member.id"
          class="flex flex-row items-center mb-4"
        >
          <div>
            <aha-avatar
              :name="`${member.firstName} ${member.lastName}`"
              :id="member.id"
              :width="36"
              :height="36"
              class="mr-2 text-lg"
            />
          </div>
          <div class="flex flex-col max-w-60 list-member-info">
            <div class="inline-flex font-bold">
              {{ getMemberName(member) }}
            </div>
            <div class="inline-flex text-xs text-base-80">
              {{ member.email }}
            </div>
          </div>
          <div class="text-xs ml-auto">
            {{ getMemberPermissionText(member.accountRole) }}
          </div>
        </div>
      </div>
    </template>
  </aha-modal-group>
</template>
<script>
import UserApi from '@/api/user'
import Util from '@/util'

export default {
  props: {
    teamName: {
      type: String,
      default: 'your current team',
    },
  },
  data() {
    return {
      teamMembers: {},
      totalMembers: '',
    }
  },
  mounted() {
    this.getMyTeam()
  },
  methods: {
    hide() {
      this.$emit('hide')
    },
    async getMyTeam() {
      if (!this.$store.state.currentUser.id) {
        return
      }

      try {
        const res = await UserApi.getTeamMembers({
          userId: this.$store.state.currentUser.id,
          size: 30,
        })
        const { totalUsers, users } = res
        this.teamMembers = users
        this.totalMembers = totalUsers
      } catch (error) {
        Util.gaTrackEvent('My Team', 'Get user team', 'Get user plan failed')
        throw error
      }
    },
    getMemberPermissionText(role) {
      if (role == 'admin') return 'Owner'
      return 'Can edit'
    },
    getMemberName(member) {
      return `${member.firstName} ${member.lastName}`.replace(/\s+/g, ' ').trim()
    },
  },

}
</script>
<style scoped lang='scss'>
.list-member {
  @apply mt-4 mb-6;
  padding-right: 2rem;
  overflow-y: auto;
  overflow-x: hidden;
  max-height: 14rem;
  .list-member-info {
    div {
      text-overflow: ellipsis;
      overflow: hidden;
      display: -webkit-box;
      -webkit-line-clamp: 1;
      line-clamp: 1;
      -webkit-box-orient: vertical;
    }
  }
}
</style>
